export function toArray(x) { return Array.isArray(x) ? x : [x]; }
export default toArray;

//# sourceMappingURL=toArray.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/utils/toArray.js
// module id = 76
// module chunks = 0